import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    RequestAttendanceMutation,
    RequestAttendanceMutationVariables,
} from './AttendWithoutAccount.mutations.generated'

export const ATTEND_EVENT_WITHOUT_ACCOUNT: TypedDocumentNode<
    RequestAttendanceMutation,
    RequestAttendanceMutationVariables
> = gql`
    mutation RequestAttendance($input: attendEventWithoutAccountInput!) {
        attendEventWithoutAccount(input: $input) {
            entity {
                guid
                ... on Event {
                    title
                }
            }
        }
    }
`
